import {
    Box,
    paletteColors,
    Stack,
    styled,
    Tooltip,
    tooltipClasses,
    TooltipProps,
} from '@evaneos/b2b-ui';

import { DossierTag } from '../../../resources/dossier/types';

import { TagChip } from './TagChip';

const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: '350px',
        backgroundColor: paletteColors.neutral[900],
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: paletteColors.neutral[900],
    },
});

export const TagsTooltipChip = ({
    tags,
    isTooltipOpen,
}: {
    tags: DossierTag[];
    isTooltipOpen?: boolean;
}) => {
    if (tags.length === 0) {
        return null;
    }

    return (
        <NoMaxWidthTooltip
            open={isTooltipOpen}
            title={
                <Stack
                    direction="row"
                    gap={1}
                    margin={0.5}
                    flexWrap="wrap"
                    onClick={(event) => event.stopPropagation()}
                >
                    {tags.map((tag) => (
                        <TagChip key={tag.id} label={tag.name} />
                    ))}
                </Stack>
            }
            placement={'top'}
            arrow
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -8],
                            },
                        },
                    ],
                },
            }}
        >
            <Box>
                <TagChip label={'Tags'} />
            </Box>
        </NoMaxWidthTooltip>
    );
};
